import { render } from "./PricingStyleTwo.vue?vue&type=template&id=078a24b3&ts=true"
import script from "./PricingStyleTwo.vue?vue&type=script&lang=ts"
export * from "./PricingStyleTwo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__